import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import sidebarHelper from "../../../helpers/sidebar";

export default function ManagePublisherMenu({ openItem, activeItem }) {
  return (
    <li
      className={`nav-item has-treeview 
        ${sidebarHelper.checkOpenItem(openItem, "manage-publisher")} `}
    >
      <a
        href="# "
        className={`nav-link  
        ${sidebarHelper.checkActiveItem(openItem, "manage-publisher")} `}
      >
        <i className="nav-icon fa fa-tasks "></i>
        <p>
          مدیریت نمایش دهندگان
          <i className="right fa fa-angle-left"></i>
        </p>
      </a>

      <ul className="nav nav-treeview">
        <li className="nav-item">
          <Link
            to="/publisher/manage/all"
            className={`nav-link  
            ${sidebarHelper.checkActiveItem(
              activeItem,
              "all-mange-publisher"
            )} `}
          >
            <i className="fa fa-image nav-icon"></i>
            <p> تمام نمایش دهندگان</p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/positions/manage/report-position"
            className={`nav-link  
            ${sidebarHelper.checkActiveItem(
              activeItem,
              "mange-report-position"
            )} `}
          >
            <i className="fa fa-image nav-icon"></i>
            <p>گزارش جایگاه ها</p>
          </Link>
        </li>
      </ul>
    </li>
  );
}
